import React from "react";
import { Callout, CalloutProps } from "../../../Callout/Callout";
import { Stack } from "../../../Stacks/Stack/Stack";
import { StopPropagation } from "../../../StopPropagation/StopPropagation";
import { OperationalContent, OperationalContentProps } from "../shared/OperationalContent";

export interface CalloutColumnProps extends OperationalContentProps {
    /**
     * Callout props to create <Callout /> element.
     */
    readonly calloutProps: readonly CalloutProps[];
}

export const CalloutColumn: React.FC<CalloutColumnProps> = ({
    calloutProps,
    operationalData,
}) => (
    <Stack horizontalAlign="start">
        <OperationalContent
            operationalData={operationalData}
        >
            <StopPropagation>
            {
                calloutProps.map((element, index) =>(

                        <Callout {...element} key={index}>
                            {element.children}
                        </Callout>
                ))
            }
            </StopPropagation>
        </OperationalContent>
    </Stack >
);
